import { useMutation } from '@apollo/client'
import { UPDATE_APPLICATION_INPUT } from '../../../../graphql/mutation'
import { GET_ALL_APPLICATIONS, GET_TRANSLATED_JSON_BY_LG } from '../../../../graphql/query'

export const UpdateApplication = (appId: string) => {
  const lang = sessionStorage.getItem('lang')

  const refetchQueries = lang
    ? [
        {
          query: GET_TRANSLATED_JSON_BY_LG,
          variables: {
            input: {
              appIdString: appId,
              targetLang: lang
            }
          },
          context: {
            headers: {
              'access-control-allow-methods': 'Bot-Builder'
            }
          }
        }
      ]
    : [
        {
          query: GET_ALL_APPLICATIONS,
          variables: {
            input: {
              appIDString: appId
            }
          },
          context: {
            headers: {
              'access-control-allow-methods': 'Bot-Builder'
            }
          }
        }
      ]

  return useMutation(UPDATE_APPLICATION_INPUT, {
    refetchQueries,
    context: {
      headers: {
        'access-control-allow-methods': 'Bot-Builder'
      }
    }
  })
}
